import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import BuildingTooltip from 'components/BuildingTooltip/BuildingTooltip.jsx'
import CommandCenterTooltip from 'components/CommandCenterTooltip/CommandCenterTooltip.jsx'
import Gamefield from 'components/Gamefield/Gamefield.jsx'
import LoadingScreen from 'components/LoadingScreen/LoadingScreen.jsx'
import StartingPoint from 'components/StartingPoint/StartingPoint.jsx'

import CommandCenter from 'containers/Stronghold/components/CommandCenter/CommandCenter.jsx'
import Direction from 'containers/Stronghold/components/Direction/Direction.jsx'

import { Statistics } from './components'

import { requestStronghold } from 'state/actions/stronghold'

import { BUILDING_TOOLTIP_ID, DIRECTIONS } from 'constants'
import { DEFAULT_LANGUAGE, localeDataHash } from 'locale'

import styles from './StrongholdExternal.scss'

export class StrongholdExternal extends React.Component {
    static propTypes = {
        level: PropTypes.number.isRequired,
        showLoading: PropTypes.bool.isRequired,
        slots: PropTypes.arrayOf(PropTypes.object).isRequired,
        clanId: PropTypes.number.isRequired,
        language: PropTypes.string.isRequired,
        clanStats: PropTypes.object,

        requestStronghold: PropTypes.func.isRequired,
    }
    componentWillMount() {
        const { language, clanId } = this.props
        this.props.requestStronghold(clanId, language)
    }
    componentDidMount() {
        document.body.classList.add(styles.body)
        document.getElementsByTagName('html')[0].classList.add(styles.html)
    }
    componentWillUnmount() {
        document.body.classList.remove(styles.body)
        document.getElementsByTagName('html')[0].classList.remove(styles.html)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.clanId !== this.props.clanId) {
            this.props.requestStronghold(nextProps.clanId, this.props.language)
        }
    }

    render() {
        let component
        let statisticsComponent

        if (this.props.showLoading) {
            component = <LoadingScreen type='gamefield' />
        } else {
            let emptySlotClickHandler = null
            let buildingClickHandler = null

            const directions = DIRECTIONS.map(directionName => {
                const directionSlots = this.props.slots
                    .filter(slot => (slot.direction === directionName))
                    .sort((firstSlot, secondSlot) => (firstSlot.position > secondSlot.position))

                return (
                    <Direction
                        key={directionName}
                        level={this.props.level}
                        name={directionName}
                        slots={directionSlots}
                        emptySlotClickHandler={emptySlotClickHandler}
                        buildingClickHandler={buildingClickHandler}
                        hasPermission={false}
                        isOwn={false}
                    />
                )
            })
            const tooltips = this.props.slots
                .map(slot => {
                    if (slot.building !== null) {
                        return (
                            <BuildingTooltip
                                key={`${BUILDING_TOOLTIP_ID}_${slot.building.type}`}
                                id={`${BUILDING_TOOLTIP_ID}_${slot.building.type}`}
                                building={slot.building}
                                bounds={{ top: 200 }}
                            />
                        )
                    }
                })
            tooltips.push(
                <CommandCenterTooltip
                    key='command_center_tooltip'
                    level={this.props.level}
                />
            )
            const commandCenter = (
                <CommandCenter
                    key={1}
                    level={this.props.level}
                    isOwn={false}
                />
            )
            component = (
                <div>
                    {[...directions, ...tooltips]}
                    <StartingPoint children={[commandCenter]}/>
                </div>
            )

            statisticsComponent = <Statistics clanStats={this.props.clanStats} />
        }

        return (
             <div className={styles.base}>
                <Gamefield type={Gamefield.TYPES.external}>
                    {component}
                </Gamefield>
                {statisticsComponent}
            </div>
        )
    }
}

export const mapStateToProps = (state, ownProps) => {
    let { buildings, slots, settings, stronghold } = state
    const clanId = parseInt(ownProps.params.clanId)
    const language = localeDataHash[ownProps.params.locale] ? ownProps.params.locale : DEFAULT_LANGUAGE

    const { loading: strongholdLoading, loaded: strongholdLoaded, level, stats: clanStats } = stronghold
    const { loading: settingsLoading, loaded: settingsLoaded } = settings

    const showLoading = strongholdLoading || !strongholdLoaded || settingsLoading || !settingsLoaded

    slots = Object.keys(slots)
        .reduce((acc, slotId) => ([
            ...acc,
            slots[slotId],
        ]), [])
        .map(slot => ({
            ...slot,
            building: ((slot.building !== null) ? buildings[slot.building] : null),
        }))

    return {
        slots,
        language,
        level,
        showLoading,
        clanId,
        clanStats,
    }
}

export const mapDispatchToProps = {
    requestStronghold,
}

export default connect(mapStateToProps, mapDispatchToProps)(StrongholdExternal)



// WEBPACK FOOTER //
// ./containers/StrongholdExternal/StrongholdExternal.jsx